import { getValidationSchema } from "@Shared/utils/validationSchema";
import * as yup from "yup";
import stateFormMeta, { IStateFormMeta } from "./StateFormMeta";
import supplierFormMeta, { ISupplierFormMeta } from "./SupplierFormMeta";

export interface IDistributionModuleFormMeta extends ISupplierFormMeta, IStateFormMeta {
  
  schema: any;
}

let distributionModuleFormMeta = {} as IDistributionModuleFormMeta;


distributionModuleFormMeta = {...distributionModuleFormMeta, ...supplierFormMeta, ...stateFormMeta };

distributionModuleFormMeta.schema = yup.object().shape(getValidationSchema(distributionModuleFormMeta));

export default distributionModuleFormMeta;